export default function getEmailsArrayFromString(emailsString) {
  return (emailsString || '')
    .split(/[  ,\r\n]+/)
    .filter(email => !!email.trim())
}
